<ng-container *ngFor="let structure of location; index as position">

    <ng-select (change)="didChangeSelection($event, position)"
               [(ngModel)]="structure.selection"
               [groupBy]="structure?.config?.groupBy"
               [items]="structure.options"></ng-select>

</ng-container>

<div class="alert alert-warning"
     role="alert"
    *ngIf="isInvalidSelection">
    <strong>Invalid selection </strong>
    – a {{ selectedNode?.type }} cannot be used as the selection for the location.
    Please select a more specific item.
</div>
